// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Divider,
  Button,
  ListItem,
  ListItemText,
  Rating,
  // TableContainer,
  // Paper,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import DataFormSubmissionCard from "app/campaigns/components/data_submission";

function PSAFeedbackPage() {
  const pageTitle = "Sampled Information";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [feedbackRecord, setFeedbackRecord] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/psa/feedbacks/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setFeedbackRecord(result.data.data.feedback);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {feedbackRecord !== null && (
        <MDBox pt={3} pb={3}>
          <MDBox>
            <Button
              color="dark"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                navigate(`/trade-marketing/promotions/product-sampling/feedbacks/${feedbackRecord.campaign}`);
              }}
            >
              Back
            </Button>
          </MDBox>
          <MDBox mt={1}>
            <Card>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                      Customer Information
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                      <Icon color="success">edit_note</Icon>
                    </MDBox>
                  </MDBox>
                  <MDBox mt={3}>
                    <MDBox>
                      <Table aria-label="campaign information">
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular">
                                Name
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {feedbackRecord.name}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular">
                                Phone Number
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {feedbackRecord.phone_number}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular">
                                Email Address
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {feedbackRecord.email_address}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular">
                                Campaign Location
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {feedbackRecord.campaign_location}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular">
                                GPS
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                <a
                                  rel="noreferrer"
                                  target="_blank"
                                  href={`https://maps.google.com?q=${feedbackRecord.lat},${feedbackRecord.lng}`}
                                >
                                  <Icon>location_on</Icon>
                                </a>
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular">
                                Date
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDTypography variant="h6" fontWeight="light">
                                {feedbackRecord.created}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          <MDBox mt={5}>
            {feedbackRecord.products.map((product) => (
              <Card>
                <MDBox p={2} mb={2}>
                  <ListItem divider>
                    <ListItemText
                      primary={<MDTypography variant="h6">{product.name}</MDTypography>}
                      secondary={
                        <MDTypography variant="body2" fontSize={12} mb={1}>
                          Buy: {product.would_buy.toUpperCase()}
                          <br />
                          Recommend: {product.would_recommend.toUpperCase()}
                        </MDTypography>
                      }
                    />
                    <Rating value={product.rating} readOnly />
                  </ListItem>
                  <MDBox mt={1}>
                    <MDTypography variant="h6" fontWeight="regular" fontSize={13}>
                      Comments:
                    </MDTypography>
                    <MDTypography variant="body2" fontSize={12}>
                      {product.comments}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </Card>
            ))}
          </MDBox>
          <MDBox mt={5}>
            <DataFormSubmissionCard data={feedbackRecord.data_form} />
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default PSAFeedbackPage;
